import {
  GET_BUNDLE_OFFERS_SUCCESS,
  GET_BUNDLE_OFFERS_FAILURE,
} from '../../../../config/constants/ActionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case GET_BUNDLE_OFFERS_SUCCESS: {
      return {
        ...state,
        bundleOffers: action.payload.bundleOffers,
      }
    }

    case GET_BUNDLE_OFFERS_FAILURE: {
      return {
        ...state,
        getBundleOffersError: action.payload.error,
      }
    }

    default:
      return state
  }
}
